import React from 'react';
import { Observer } from 'mobx-react';
import { createUseStyles } from 'react-jss';
import { ThemeProps } from '@styles/theme';

import { SummaryPanel } from '@shared/components/SummaryPanel';

import UsersIcon from '@assets/users.svg';
import InstructorsIcon from '@assets/instructors.svg';

import { messages } from 'Licenses/license.messages';
import { ILicensesStatisticsStore } from 'Licenses/stores/LicensesStatistics.store';
import { useTheme } from '@mui/material/styles';

const useStyles = createUseStyles((theme: ThemeProps) => ({
    panelWrapper: {
        marginBottom: theme.spacing(3),
        display: 'flex',
        justifyContent: 'center',
    },
}));
type LicensesSummaryProps = {
    statistics: ILicensesStatisticsStore,
    className?: string,
};
export const LicensesSummary: React.FC<LicensesSummaryProps> = ({ statistics, className }) => {
    const theme = useTheme<ThemeProps>();
    const styles = useStyles({ theme });

    const renderValue = (value: number | null) => value === null ? '' : value;

    return (
        <Observer>
            {() => {

                const preparedData = [
                    {
                        id: 0,
                        title: messages['licensesSummary.player.title'],
                        text: messages['licensesSummary.player.text'](renderValue(statistics.playersCount)),
                        icon: UsersIcon,
                    },
                    {
                        id: 1,
                        title: messages['licensesSummary.creator.title'],
                        text: messages['licensesSummary.creator.text'](renderValue(statistics.creatorsCount)),
                        icon: InstructorsIcon,
                    }
                ];


                const title = messages['licensesSummary.title'];

                return (
                    <div className={styles.panelWrapper}>
                        <SummaryPanel
                            className={className}
                            title={title}
                            items={preparedData}
                            hideTitle
                        />
                    </div>
                )
            }}
        </Observer>
    )
}
